import SelectDropdown from 'components/SelectDropdown';
import { Field, useFormikContext } from 'formik';
import React from 'react';
import { OfferType } from 'legacy/events/types';
import KickbackKindButton from './components/KickbackKindButton';
import classnames from 'classnames';
import styles from 'legacy/common/components/form/Form.module.scss';

const Kickback = () => {
  const { values, setFieldValue, errors } = useFormikContext<OfferType>();
  const kickbackRewards = values.rewards.kickbackRewards;
  const handleChange = (value: string) => {
    setFieldValue('rewards.kickbackRewards.kind', value);
  };

  return (
    <>
      <div className="mt-6">
        <div className="text-[16px] text-[#202020] font-bold">Kickback</div>
        <div className="text-sm mt-2 text-[#575757] font-normal">
          Reward promoters for bringing in ticket sales. Set a payout per ticket
          through their unique link or code.
        </div>
      </div>
      <div className="mt-4 flex flex-row">
        <Field
          id="kind"
          name="kind"
          label="Discount type*"
          render={() => (
            <KickbackKindButton
              kind={kickbackRewards.kind}
              handleChange={handleChange}
            />
          )}
          className="flex"
        />
        <Field
          id="amount"
          name="amount"
          type="number"
          label="Discount amount*"
          placeholder={
            kickbackRewards.kind === 'percentage' ? 'e.g. 15%' : 'e.g. $15'
          }
          onChange={(e) =>
            setFieldValue('rewards.kickbackRewards.value', e.target.value)
          }
          className={classnames(
            'border-1 border-[#DCDCDC] rounded-md flex ml-2 max-w-[100px] px-2',
            {
              [styles.errorField]: errors.rewards?.kickbackRewards?.value
            }
          )}
        />

        <div className="flex-1 ml-2">
          <SelectDropdown
            onChange={(value) =>
              setFieldValue(
                'rewards.kickbackRewards.saleConditions.unit',
                value
              )
            }
            value={kickbackRewards.saleConditions.unit}
            data={[
              // { value: 'order', label: 'Per Order' },
              { value: 'ticket', label: 'Per Ticket' }
            ]}
            textValueStyle={dropdownStyle}
            controlStyle={controlStyle}
          />
        </div>
      </div>
      {errors.rewards?.kickbackRewards?.value && (
        <div className={classnames(styles.error)}>
          {errors.rewards?.kickbackRewards?.value}
        </div>
      )}
    </>
  );
};

const dropdownStyle = {
  color: '#202020',
  fontWeight: 400,
  fontSize: 14
};

const controlStyle = {
  borderColor: '#DCDCDC'
};

export default Kickback;
